/* src/app/private/components/packages/addon-list/addon-list.component.scss */
/*# sourceMappingURL=addon-list.component.css.map */
